







import { Component, Prop, Vue } from 'vue-property-decorator';
import { MultiColumnBlockDto } from '@/api';
import BlocksDispatcher from '@/views/cms/BlocksDispatcher.vue';

@Component({
  components: {BlocksDispatcher},
})
export default class MultiColumnBlock extends Vue {
  @Prop({required: true})
  public readonly model!: MultiColumnBlockDto;

  get containerStyle(): any {
    return {
      'background-color': this.model.backgroundColor,
    };
  }

  get leftBlockStyle(): any {
    return {
      'flex-grow': this.model.leftColumnGrow,
    };
  }
}
